function subpage() {
	const mainSubpage = document.querySelector('main.subpage');
	if (!mainSubpage) return;

	ScrollTrigger.create({
		trigger: ".text-parallax",
		start: "top center",
		end: "top top",
		onUpdate: function (self) {
			var scrollValue = self.progress * 100;
			var scrollValuePercents = Math.round(( (scrollValue + Number.EPSILON) * 100) / 100 ) / 4;
			$('.text-parallax .text-content').css('transform', 'translateY(-' + scrollValuePercents + '%');
		}
	});


}
